/*
 * @Author: Teemo Ding
 * @Date: 2021-10-28 16:46:47
 * @LastEditTime: 2022-08-26 15:23:30
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/ShoppingCartTemplate/List/index.tsx
 */
import { NoDataPage } from '@/src/components';
import Breadcrumb from '@/src/components/Antd/Breadcrumb/Breadcrumb';
import GlobalTable from '@/src/constrains/BulkEditorTable/BulkEditorTable2';
import { useI18n } from '@/src/hooks/useRouterChange';
import {
  getShoppingCartTemplateList,
  getShoppingCartTemplates,
} from '@/src/request/order';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import { useQueries, useSelectRows } from '@/src/tools/hooks/listPageHooks';
import { i18nGet } from '@/src/tools/tools';
import {
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
  EPermissionSource,
} from '@/src/types/common/resources';
import moment from 'moment';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import ListPageLayout from 'src/layout/ListPageLayout/ListPageLayout';
// import { getCurrencies } from 'src/constrains/ConfigProvider/slice';
// import { useSelector } from 'react-redux';
import { defaultPageSize, NEW } from 'src/tools/constant';
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { breadcrumbData, columns, ETab, tabDict, tabsConfig } from './config';
import css from './css.module.less';

const permissions = () => {
  const view_shopping_cart_template_listing_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderCartTemplate,
        operation: EnumOperation.view_shopping_cart_template_listing_page,
      }),
    ],
  });
  const view_shopping_cart_template_details_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderCartTemplate,
        operation: EnumOperation.view_shopping_cart_template_details_page,
      }),
    ],
  });
  const create_edit_shopping_cart_template = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderCartTemplate,
        operation: EnumOperation.create_edit_shopping_cart_template,
      }),
    ],
  });
  const notify_customer = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderCartTemplate,
        operation: EnumOperation.notify_customer,
      }),
    ],
  });
  const switch_status = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderCartTemplate,
        operation: EnumOperation.switch_status,
      }),
    ],
  });
  const delete_shopping_cart_template = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderCartTemplate,
        operation: EnumOperation.delete_shopping_cart_template,
      }),
    ],
  });
  return {
    view_shopping_cart_template_listing_page,
    view_shopping_cart_template_details_page,
    create_edit_shopping_cart_template,
    notify_customer,
    switch_status,
    delete_shopping_cart_template,
  };
};

const customerConvertQuery = (filter) => {
  // console.log('filter',filter)
  const re: any = {};

  return re;
};

const ShoppingCartTemplatesList = () => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    view_shopping_cart_template_listing_page,
    view_shopping_cart_template_details_page,
    create_edit_shopping_cart_template,
  } = permissions();
  // console.log('currencies', currencies);
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  /* 分页 */
  const [current, setCurrent] = useState(0);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [noProducts, setNoProducts] = useState(true);
  const [sortBy, setSortBy] = useState<any>({});
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [tabsActive, setTabsActive] = useState(ETab.all);
  const [timezoneInGmt, setTimezoneInGmt] = useState('');
  const [currency, setCurrency] = useState('');
  //console.log('tabsActive', tabsActive);
  //分页配置
  const paginationProps = {
    defaultPageSize: pageSize,
    showQuickJumper: true,
  };

  const { clearSearchState, queryProps, search } = useQueries(
    [],
    [],
    customerConvertQuery,
  );

  const statuses = tabDict[tabsActive];
  const conditions = {
    statuses,
    ...search,
    ...(Object.keys(sortBy).length ? { sortBy } : {}),
    startDate,
    endDate,
  };

  /* 多选 */
  const {
    rowSelection,
    selectedRowKeys,
    selectedAll,
    setSelectedAll,
    setMappedSelectedKeys,
    //mappedSelectedKeys,
    setSelectedRowKeys,
  } = useSelectRows(data);

  const buttonMenu = [
    //不知道
    //Bulk Edit
    // {
    //   key: 1,
    //   value: 'Invoices',
    //   function: () => {
    //     if (selectedRowKeys.length > 0) {
    //       printInvoice({ orderUuids: selectedRowKeys }).then((data) => {
    //         console.log(data, 'data=====>');
    //       });
    //     }
    //   },
    // },
  ];

  //清除table状态
  const clearTableState = () => {
    setSelectedRowKeys([]);
    setMappedSelectedKeys([]);
    setSelectedAll(false);
  };

  //tab改变事件
  const tabChange = (activeKey) => {
    clearTableState();
    clearSearchState();
    setCurrent(0);
    // setStartDate('');
    // setEndDate('');
    setSortBy({});
    setTabsActive(activeKey);
  };

  const getProduct = (cb) => {
    if (!loading) {
      setLoading(true);
    }
    const data = search;
    data.logisticsMethod = [];
    getShoppingCartTemplateList(current * pageSize, pageSize, conditions)
      .then((res) => {
        //console.log(res);
        const { results } = res;
        setData(results || []);
        //setTotal(totalCount);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  React.useEffect(() => {
    if (view_shopping_cart_template_listing_page) {
      getShoppingCartTemplates(current * pageSize, pageSize, conditions).then(
        (res) => {
          //console.log(res);
          const {
            templates: { results, totalCount },
            timezoneInGmt,
            currency,
          } = res;
          setTimezoneInGmt(timezoneInGmt);
          setCurrency(currency);
          setData(results || []);
          setTotal(totalCount);
          setLoading(false);
          setNoProducts(!totalCount);
        },
      );
    } else {
      setLoading(false);
    }
  }, []);

  useAfterDidMountEffect(() => {
    if (view_shopping_cart_template_listing_page) {
      getProduct(() => void 0);
    }
  }, [current]);

  useAfterDidMountEffect(() => {
    if (view_shopping_cart_template_listing_page) {
      if (!current) {
        getProduct(() => void 0);
      } else {
        setCurrent(0);
      }
    }
  }, [pageSize, search, sortBy, startDate, endDate]);

  const handleLinkToAddOrder = () => {
    history.push(`/order/shoppingCart/edit/${NEW}`);
  };

  const pageLayoutProps = {
    title: getI18n(
      'shoppingCartTemplate.shoppingCartTemplate.list_pageLayoutProps_title',
    ),
    addText: getI18n(
      'shoppingCartTemplate.shoppingCartTemplate.list_pageLayoutProps_addText',
    ),
    addFun: handleLinkToAddOrder,
    tabChange,
    activeKey: tabsActive,
    tabsConfig: tabsConfig(getI18n),
    disableAdd: !create_edit_shopping_cart_template,
  };

  const handleTimePickerOnChange = (data) => {
    if (data) {
      setStartDate(data[0].format('YYYY-MM-DD'));
      setEndDate(data[1].format('YYYY-MM-DD'));
    } else {
      setStartDate('');
      setEndDate('');
    }
  };

  return (
    <React.Fragment>
      <Breadcrumb
        className={css.breadcrumb}
        breadcrumbData={breadcrumbData(getI18n)}></Breadcrumb>
      {noProducts ? (
        <NoDataPage
          title={getI18n(
            'shoppingCartTemplate.shoppingCartTemplate.list_return_noProduct_Yes_title',
          )}
          introduce={getI18n(
            'shoppingCartTemplate.shoppingCartTemplate.list_return_noProduct_Yes_introduce',
          )}
          buttonTitle={getI18n(
            'shoppingCartTemplate.shoppingCartTemplate.list_return_noProduct_Yes_buttonTitle',
          )}
          onClick={handleLinkToAddOrder}
          disabled={!create_edit_shopping_cart_template}
        />
      ) : (
        <ListPageLayout {...pageLayoutProps} tabChange={tabChange}>
          <GlobalTable
            id='OrderShoppingCartTemplate'
            showTimePicker
            timePickerValue={[
              startDate ? moment(startDate) : null,
              endDate ? moment(endDate) : null,
            ]}
            timePickerOnChange={handleTimePickerOnChange}
            queryProps={queryProps}
            dataSource={data || []}
            columns={columns(timezoneInGmt, currency, currency, { getI18n })}
            selectedAll={selectedAll}
            setSelectedAll={setSelectedAll}
            buttonMenu={buttonMenu}
            rowKey='uuid'
            pagination={paginationProps}
            current={current}
            setCurrent={setCurrent}
            pageSize={pageSize}
            setPageSize={setPageSize}
            total={total}
            holdHeader
            bulkEditText={getI18n(
              'shoppingCartTemplate.shoppingCartTemplate.list_return_noProduct_No_bulkEditText',
            )}
            rowSelection={rowSelection}
            selectedRowKeys={selectedRowKeys}
            hidePagination={total == 0}
            onRow={(record) => ({
              onClick: view_shopping_cart_template_details_page
                ? () => {
                    history.push(`/order/shoppingCart/edit/${record.uuid}`);
                  }
                : null,
              //
            })}
            onChange={(_, s, sort) => {
              //console.log('sort', sort);
              const ascent = sort.order == 'ascend' ? true : false;
              const field = sort.columnKey;
              setSortBy({ field, ascent });
            }}
            loading={loading}
          />
        </ListPageLayout>
      )}
    </React.Fragment>
  );
};

export default ShoppingCartTemplatesList;
